let UserFactory = function () {
  const user = {
    codingOperationsTeam: '',
    name: '',
    email: '',
    specialty: '',
    role: '',
    worklist: '',
    id: '',
    token: '',
    roleId: '',
    initialLogin: '',
    activeDirectoryToken: '',
    campus: ''
  };

  let setUser = (codingOperationsTeam, name, email, specialty, role, worklist, id, token, roleId, activeDirectoryToken, initialLogin, campus) => {
    user.codingOperationsTeam = codingOperationsTeam,
    user.name = name;
    user.email = email;
    user.specialty = specialty;
    user.role = role;
    user.worklist = worklist;
    user.id = id;
    user.token = token;
    user.roleId = roleId;
    user.activeDirectoryToken = activeDirectoryToken;
    user.initialLogin = initialLogin;
    user.campus = campus;
  }

  let getUser = () => {
    return user;
  };

  let isSignedIn = () => {
    return user.isSignedIn;
  };

  return { getUser, isSignedIn, setUser };
};

export default UserFactory;



// WEBPACK FOOTER //
// ./client/app/common/user/user.factory.js